import React from 'react';
import Page from 'components/Page';

const ColourSchemes = () => {
    return (
        <Page>
            <h1>Colour Schemes</h1>
            <p>Colour schemes content will be added here.</p>
        </Page>
    );
};

export default ColourSchemes;
